export class BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mergedDatabaseName",
            "baseName": "mergedDatabaseName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourceTableMappingMergeDatabasesParams.attributeTypeMap;
    }
    constructor() {
    }
}
